import React, { useContext, useEffect } from "react";
import "../../Styles/globalStyle.css";
import "./FormSettings.css";
import AccordionList from "../../AccordionList/AccordionList";
import DiagramList from "../../DiagramList/DiagramList";
import SideBar from "../../SideBar/SideBar";
import Form from "../../Form/Form";
import Tools from "../../Tools/Tools";
import { store } from "../../../store.js";

export default function FormSettings(props) {
  const globalState = useContext(store);
  return (
    <div className="middleFormContainer" style= {{  paddingTop: "20px"}}>
     
      <div className="leftForm">
        <Form  isExecutionMode={props.isExecutionMode}/>
      </div>

      {(!globalState.state.formData.currentMetaData.isSealed && !props.isExecutionMode) && <div className="rightForm">
        <Tools tools={globalState.state.tools} />
      </div>}
    </div>
  );
}


/*
<div className="leftForm">
        <Form  isExecutionMode={props.isExecutionMode}/>
      </div>*/
